import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-4">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center">
              <FileText className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900">Terms of Service</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200">
          <p className="text-slate-500 text-sm mb-8">Last updated: January 2025</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-6">
              By accessing and using Review Responder, you accept and agree to be bound by these 
              Terms of Service. If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Description of Service</h2>
            <p className="text-slate-600 mb-6">
              Review Responder is an AI-powered tool that helps businesses manage and respond to 
              Google Business reviews. Our service generates suggested responses using artificial 
              intelligence and allows you to post them directly to Google.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. User Responsibilities</h2>
            <p className="text-slate-600 mb-6">
              You are responsible for maintaining the confidentiality of your account and for all 
              activities that occur under your account. You agree to review and edit AI-generated 
              responses before posting to ensure accuracy and appropriateness.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Subscription and Billing</h2>
            <p className="text-slate-600 mb-6">
              Paid subscriptions are billed monthly. You can cancel your subscription at any time, 
              and you will continue to have access until the end of your billing period. Refunds 
              are provided at our discretion.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. AI-Generated Content</h2>
            <p className="text-slate-600 mb-6">
              While we strive to generate helpful and appropriate responses, AI-generated content 
              may not always be perfect. You are responsible for reviewing and approving all 
              responses before they are posted. We are not liable for any issues arising from 
              posted content.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Limitation of Liability</h2>
            <p className="text-slate-600 mb-6">
              Our service is provided "as is" without warranties of any kind. We shall not be 
              liable for any indirect, incidental, special, or consequential damages resulting 
              from your use of our service.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Termination</h2>
            <p className="text-slate-600 mb-6">
              We reserve the right to terminate or suspend your account at any time for violations 
              of these terms or for any other reason at our sole discretion.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Changes to Terms</h2>
            <p className="text-slate-600 mb-6">
              We may update these terms from time to time. We will notify you of any material 
              changes by posting the new terms on our website. Your continued use of the service 
              after changes constitutes acceptance.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Contact</h2>
            <p className="text-slate-600">
              For any questions about these Terms of Service, please contact us at{' '}
              <Link to="/contact" className="text-blue-600 hover:underline">our contact page</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
